// import CustomSearchDropdown from "../../POP/FileComp5";
// import _ from "lodash";
// import { useSearchParams, useNavigate } from "react-router-dom";
// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import TableCompoenent from "./TableCompoenent";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import DropDownCB from "../components/SingleDropdwon";
// import DropDownMultipleSelection from "../components/FieldsComponent";
// import FormInputs from "../DummyReportPage/FormInputs";
// import dayjs from "dayjs";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";

// const StudentTestPerformanceReport = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   pauseTimer,
//   resumeTimer,
//   dataClient,
//   setPagePath,
// }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { coursesdata } = useSelector((state) => state.course);

//   // --- UI States ---
//   const [resultsData, setResultsData] = useState([]);
//   const [headers, setHeaders] = useState([]);
//   const [isApplied, setIsApplied] = useState(false);
//   const [resetKey, setResetKey] = useState(0);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isVisible, setIsVisible] = useState(true);
//   const [disabled, setDisabled] = useState(false);
//   const [isExpanded, setIsExpanded] = useState(false);

//   // --- Dropdown Data States ---
//   const [sessionData, setSessionData] = useState([]);
//   const [batchData, setBatchData] = useState([]);
//   const [studentData, setStudentData] = useState([]);
//   const [v2AssessmentData, setV2AssessmentData] = useState([]);
//   const [v3TestData, setV3TestData] = useState([]);

//   // --- Selected Values States ---
//   const [selectedCourseId, setSelectedCourseId] = useState("");
//   const [selectedSessionId, setSelectedSessionId] = useState("");
//   const [selectedBatchId, setSelectedBatchId] = useState("");
//   const [selectedStudents, setSelectedStudents] = useState([]);
//   const [selectedV3TestIds, setSelectedV3TestIds] = useState([]);
//   const [selectedV2AssessmentIds, setSelectedV2AssessmentIds] = useState([]);

//   // --- New Filter States ---
//   const [lastNTests, setLastNTests] = useState("");
//   const [lastNDays, setLastNDays] = useState("");

//   // --- Search States ---
//   const [searchKey, setSearchKey] = useState("");
//   const [searchColumn, setSearchColumn] = useState("");

//   // --- Date/Filter Logic ---
//   const [value, setValues] = useState({
//     month: "Month to Date",
//     start_month: "",
//     end_month: "",
//   });

//   const [searchParams] = useSearchParams();
//   const reportName = searchParams.get("reportName") || "Student Test Performance";

//   // --- 1. Initial Setup ---
//   useEffect(() => {
//     setPagePath("Reports > Reports Dashboard > Test Performance");
//     dispatch(fetchCourseData());
//     fetchSessionsData();
//   }, [dispatch]);

//   // --- 2. Cascading Dropdown Logic ---
//   useEffect(() => {
//     if (selectedCourseId && sessionData.length > 0) {
//       const mostRecentSession = sessionData.reduce((prev, current) =>
//         prev.id > current.id ? prev : current
//       );
//       setSelectedSessionId(mostRecentSession.id);
//     } else if (!selectedCourseId) {
//       setSelectedSessionId("");
//     }
//   }, [selectedCourseId, sessionData]);

//   useEffect(() => {
//     if (selectedCourseId) {
//       fetchBatchData();
//     }
//     setSelectedBatchId("");
//     setBatchData([]);
//     resetDownstreamFilters();
//   }, [selectedCourseId]);

//   const filteredBatchData = useMemo(() => {
//     if (!selectedSessionId) return batchData;
//     return batchData.filter((batch) => batch.session_id === selectedSessionId);
//   }, [batchData, selectedSessionId]);

//   useEffect(() => {
//     if (selectedCourseId && selectedBatchId) {
//       fetchStudentData();
//       fetchV2AssessmentData();
//     }
//     resetDownstreamFilters();
//   }, [selectedBatchId]);

//   useEffect(() => {
//     if (selectedBatchId && selectedStudents.length > 0) {
//       fetchV3TestData(selectedStudents[0]);
//     } else {
//       setV3TestData([]);
//     }
//   }, [selectedStudents, selectedBatchId]);

//   const resetDownstreamFilters = () => {
//     setSelectedStudents([]);
//     setSelectedV3TestIds([]);
//     setSelectedV2AssessmentIds([]);
//     setStudentData([]);
//   };

//   // --- 3. API Calls ---
//   const fetchSessionsData = async () => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-sessions-list`,
//         { headers: { accept: "application/json", "Content-Type": "application/json" } }
//       );
//       const result = await response.json();
//       if (result.status === 200 && result.data) {
//         setSessionData(result.data.map((s) => ({ id: s.session_id, label: s.session_name })));
//       }
//     } catch (error) {
//       console.error("Error fetching sessions:", error);
//     }
//   };

//   const fetchBatchData = async () => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-batches-by-course/?course_id=${selectedCourseId}`,
//         { headers: { accept: "application/json", "Content-Type": "application/json" } }
//       );
//       const data = await response.json();
//       if (Array.isArray(data)) {
//         setBatchData(data.map((b) => ({
//           id: b.batch_id,
//           label: b.batch_name,
//           session_id: b.session_id,
//         })));
//       }
//     } catch (error) {
//       console.error("Error fetching batches:", error);
//     }
//   };

//   const fetchStudentData = useCallback(async () => {
//     try {
//       if (!selectedCourseId || !selectedBatchId) return;
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-v2/?course_id=${selectedCourseId}`,
//         {
//           method: "POST",
//           headers: { accept: "application/json", "Content-Type": "application/json" },
//           body: JSON.stringify({
//             batch_ids: [selectedBatchId],
//             student_ids: [],
//             search_key: searchKey,
//             search_column: searchColumn,
//           }),
//         }
//       );
//       const data = await response.json();
//       const uniqueStudents = _.uniqBy(data.student_list, "student_id");
//       setStudentData(uniqueStudents.map((s) => ({
//         id: s.student_id,
//         student_name: s.student_name,
//         roll_number: s.roll_number,
//         batch_name: s.batch_name,
//       })));
//     } catch (error) {
//       console.error("Error fetching students:", error);
//     }
//   }, [selectedCourseId, selectedBatchId, searchKey, searchColumn]);

//   const fetchV2AssessmentData = async () => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-dpps-by-batch?batch_id=${selectedBatchId}`,
//         { headers: { accept: "application/json", "Content-Type": "application/json" } }
//       );
//       const result = await response.json();
//       if (result.status === 200 && result.data) {
//         setV2AssessmentData(
//           _.uniqBy(result.data.map((d) => ({ id: d.schedule_id, label: d.assessment_name })), "id")
//         );
//       }
//     } catch (error) {
//       console.error("Error fetching V2 assessments:", error);
//     }
//   };

//   const fetchV3TestData = async (studentId) => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-tests-assignment-v3/?student_id=${studentId}&batch_id=${selectedBatchId}`,
//         { headers: { accept: "application/json", Authorization: `Bearer ${sessionStorage.getItem("other")}` } }
//       );
//       const result = await response.json();

//       if (result.status === 200 && result.data) {
//         const v3Tests = result.data
//           .filter(item => item.test_schedule_id)
//           .map(item => ({
//             id: item.test_schedule_id,
//             label: item.assessment_name + (item.test_mode ? ` (${item.test_mode})` : "")
//           }));

//         setV3TestData(_.uniqBy(v3Tests, "id"));
//       }
//     } catch (error) {
//       console.error("Error fetching V3 tests:", error);
//     }
//   };

//   // --- 4. Search & Helper Functions ---
//   const handleSearchKeyChange = (key, dropdownType) => {
//     if (key.length >= 3 && dropdownType === "student") {
//       setSearchKey(key);
//       setSearchColumn(dropdownType);
//     } else {
//       setSearchKey("");
//       setSearchColumn("");
//     }
//   };

//   const handleDropdownClose = () => {
//     if (selectedCourseId && selectedBatchId) fetchStudentData();
//   };

//   const handleRadioChange = (selectedValue) => {
//     setValues(prev => ({ ...prev, month: prev.month === selectedValue ? "" : selectedValue }));
//   };

//   const calculateDates = () => {
//     const today = dayjs();
//     if (!value.month) return { from_date: "", end_date: "" };

//     let from_date = "", end_date = today.format("YYYY-MM-DD");
//     switch (value.month) {
//       case "Last Month":
//         from_date = today.subtract(1, "month").startOf("month").format("YYYY-MM-DD");
//         end_date = today.subtract(1, "month").endOf("month").format("YYYY-MM-DD");
//         break;
//       case "Month to Date":
//         from_date = today.startOf("month").format("YYYY-MM-DD");
//         break;
//       case "Week to Date":
//         from_date = today.startOf("week").format("YYYY-MM-DD");
//         break;
//       case "Custom":
//         from_date = value.start_month;
//         end_date = value.end_month;
//         break;
//       default: break;
//     }
//     return { from_date, end_date };
//   };

//   // --- 5. Apply / Reset ---
//   const handleApplyOrReset = async () => {
//     if (isApplied) {
//       setResultsData([]);
//       setHeaders([]);
//       setIsApplied(false);
//       setIsColumnDivVisible(false);
//       setDisabled(false);
//       setResetKey(prev => prev + 1);
//       // Reset filter inputs
//       setLastNTests("");
//       setLastNDays("");
//     } else {
//       setIsApplied(true);
//       setDisabled(true);
//       const { from_date, end_date } = calculateDates();

//       const params = new URLSearchParams();
//       if (selectedBatchId) params.append("batch_ids", selectedBatchId);
//       if (selectedCourseId) params.append("course_ids", selectedCourseId);
//       if (selectedStudents.length > 0) params.append("student_ids", selectedStudents.join(","));
//       if (selectedSessionId) params.append("session_ids", selectedSessionId);
//       if (selectedV3TestIds.length > 0) params.append("test_schedule_ids", selectedV3TestIds.join(","));
//       if (selectedV2AssessmentIds.length > 0) params.append("assessment_assignment_ids", selectedV2AssessmentIds.join(","));

//       // New Params
//       if (lastNTests) params.append("last_n_tests", lastNTests);
//       if (lastNDays) params.append("last_n_days", lastNDays);

//       // Only append dates if "Custom" or predefined range selected
//       if (from_date && !lastNTests && !lastNDays) params.append("from_date", from_date);
//       if (end_date && !lastNTests && !lastNDays) params.append("end_date", end_date);

//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/student-test-performance?${params.toString()}`,
//           {
//             method: "GET",
//             headers: {
//               accept: "application/json",
//               Authorization: `Bearer ${sessionStorage.getItem("other")}`
//             },
//           }
//         );

//         const result = await response.json();

//         if (Array.isArray(result) && result.length > 1) {
//           const rawHeaders = result[0];
//           const cleanHeaders = rawHeaders.map(h => h.replace(/^[nt]\*/, ""));

//           setHeaders(cleanHeaders);
//           setResultsData(result.slice(1));
//         } else {
//           setResultsData([]);
//           showError("No data found for the selected filters.", InterogativeImg);
//         }
//       } catch (error) {
//         console.error(error);
//         setResultsData([]);
//         showError("Failed to generate report.", ErrorImg);
//       }
//     }
//   };

//   const showError = (msg, img) => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX" onMouseEnter={pauseTimer} onMouseLeave={resumeTimer}>
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>{msg}</span>
//         </div>
//       </div>
//     );
//     setActiveImg(img);
//   };

//   const dropdownStyle = isApplied ? { opacity: 0.5, pointerEvents: "none" } : { opacity: 1, pointerEvents: "auto" };

//   return (
//     <div style={{ height: "auto", width: "100%", paddingLeft: "36.5px", marginBottom: "40px" }}>
//       {/* --- Header --- */}
//       <div style={{ position: "sticky", top: "0" }}>
//         <div className="Header-up">
//           <span style={{ color: "#2F2E40", fontSize: "30px", textTransform: "capitalize" }}>
//             {reportName}
//           </span>
//           <div className="testreportcard-header-btn-container" style={{ marginRight: "30px" }}>
//             <button
//               className="testreportcard-cancel-btn"
//               onClick={() => {
//                 navigate("/report_management");
//                 setPagePath("Reports > Reports Dashboard");
//               }}
//             >
//               CANCEL
//             </button>
//             <button className="testreportcard-create-btn" onClick={handleApplyOrReset}>
//               {isApplied ? "RESET" : "APPLY"}
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* --- Filter Section --- */}
//       <div style={{ display: isVisible ? "block" : "none", marginTop: "1vh" }}>

//         {/* Row 1: Course, Session, Batch */}
//         <div className="row-cs-uni">
//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }} key={`course_${resetKey}`}>
//             <DropDownCB
//               label="Course"
//               style={{ width: "13.5vw" }}
//               selected={selectedCourseId}
//               setSelected={setSelectedCourseId}
//               options={coursesdata ? coursesdata.map(c => ({ id: c.course_id, label: c.course_description })) : []}
//             />
//           </div>
//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }} key={`session_${resetKey}`}>
//             <DropDownCB
//               label="Select Session"
//               style={{ width: "13.5vw" }}
//               selected={selectedSessionId}
//               setSelected={setSelectedSessionId}
//               options={sessionData}
//             />
//           </div>
//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }} key={`batch_${resetKey}`}>
//             <DropDownCB
//               label="Select Batch"
//               style={{ width: "13.5vw" }}
//               selected={selectedBatchId}
//               setSelected={setSelectedBatchId}
//               options={filteredBatchData}
//               disabled={!selectedCourseId}
//             />
//           </div>
//         </div>

//         {/* Row 2: Student, Assessments, Tests */}
//         <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//           {/* Student Dropdown */}
//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }} key={`student_${resetKey}`}>
//             <CustomSearchDropdown
//               label="Select Student"
//               optionsData={studentData}
//               selected={selectedStudents}
//               setSelected={setSelectedStudents}
//               placeholder="Search Student..."
//               headers={["Student Name", "Roll Number", "Batch"]}
//               optionFields={{ option1: "student_name", option2: "roll_number", option3: "batch_name" }}
//               onDropdownClose={handleDropdownClose}
//               onSearchKeyChange={(key) => handleSearchKeyChange(key, "student")}
//               customwidth="13.5vw"
//               dropdownWidth="13.5vw"
//             />
//           </div>

//           {/* V2 Assessment Dropdown (Batch Level) */}
//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }} key={`v2_${resetKey}`}>
//             <DropDownMultipleSelection
//               width="13.5vw"
//               label="Assessments"
//               selected={selectedV2AssessmentIds}
//               setSelected={setSelectedV2AssessmentIds}
//               options={v2AssessmentData}
//               customWidth="100%"
//               showSelectAll={true}
//               disabled={!selectedBatchId}
//             />
//           </div>

//           {/* V3 Test Dropdown (Student Level) */}
//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }} key={`v3_${resetKey}`}>
//             <DropDownMultipleSelection
//               width="13.5vw"
//               label="Tests"
//               selected={selectedV3TestIds}
//               setSelected={setSelectedV3TestIds}
//               options={v3TestData}
//               customWidth="100%"
//               showSelectAll={true}
//               disabled={selectedStudents.length === 0}
//             />
//             {/* {selectedStudents.length === 0 && (
//                <span style={{fontSize: '10px', color: 'gray', marginLeft: '5px'}}>*Select Student to load tests</span>
//             )} */}
//           </div>
//         </div>

//         {/* Row 3: Advanced Filters (Last N Tests, Last N Days) - PLACED HERE */}
//         <div className="row-cs-uni" style={{ marginTop: "1vh", alignItems: "center" }}>
//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }}>
//             <label style={{ fontSize: "14px", color: "#2F2E40", marginRight: "10px" }}>Last N Tests:</label>
//             <FormInputs
//               type="number"
//               placeholder="e.g. 5"
//               value={lastNTests}
//               onChange={(e) => setLastNTests(e.target.value)}
//               disabled={isApplied}
//               style={{ width: "80px", height: "30px", border: "1px solid #ccc", paddingLeft: "5px" }}
//             />
//           </div>

//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }}>
//             <label style={{ fontSize: "14px", color: "#2F2E40", marginRight: "10px" }}>Last N Days:</label>
//             <FormInputs
//               type="number"
//               placeholder="e.g. 30"
//               value={lastNDays}
//               onChange={(e) => setLastNDays(e.target.value)}
//               disabled={isApplied}
//               style={{ width: "80px", height: "30px", border: "1px solid #ccc", paddingLeft: "5px" }}
//             />
//           </div>
//         </div>

//         {/* Row 4: Date Filters (Moved Below) */}
//         <div className="grid-container-radio-button" style={{ marginTop: "1vh", height: "35px", ...dropdownStyle }}>
//           {["Last Month", "Month to Date", "Week to Date", "Custom"].map((opt) => (
//             <div className={`item${opt === "Custom" ? 8 : 5}`} key={opt}>
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id={opt}
//                   name="month"
//                   value={opt}
//                   checked={value.month === opt}
//                   onClick={() => handleRadioChange(opt)}
//                   onChange={()=>{}}
//                   disabled={isApplied || lastNTests || lastNDays} // Disable if advanced filters used
//                 />
//                 <label htmlFor={opt}>{opt}</label>
//               </div>
//             </div>
//           ))}

//           {value.month === "Custom" && (
//             <>
//               <div className="item9">
//                 <FormInputs type="date" value={value.start_month} onChange={(e) => setValues({ ...value, start_month: e.target.value })} disabled={isApplied || lastNTests || lastNDays} />
//               </div>
//               <div className="item10">To</div>
//               <div className="item11">
//                 <FormInputs type="date" value={value.end_month} onChange={(e) => setValues({ ...value, end_month: e.target.value })} disabled={isApplied || lastNTests || lastNDays} />
//               </div>
//             </>
//           )}
//         </div>

//       </div>

//       {/* --- Table Section --- */}
//       <div style={{ position: "relative", marginTop: "20px" }}>
//         <button
//           style={{
//             position: "absolute",
//             top: "-1px",
//             left: "50%",
//             transform: "translateX(-50%)",
//             zIndex: 1,
//             width: "60px",
//             height: "10px",
//             backgroundColor: "white",
//             border: "none",
//             cursor: 'pointer'
//           }}
//           onClick={() => {
//             setIsExpanded(!isExpanded);
//             setIsVisible(!isVisible);
//           }}
//         >
//           <p style={{ fontSize: "20px", color: "black", margin: 0, lineHeight: "10px" }}>...</p>
//         </button>

//         <TableCompoenent
//           headers={headers}
//           data={resultsData}
//           searchPlaceholder="Search results..."
//           isColumnDivVisible={isColumnDivVisible}
//           setIsColumnDivVisible={setIsColumnDivVisible}
//           dataClient={dataClient}
//           ReportPageHeader={reportName}
//           course={coursesdata?.find(c => c.course_id === selectedCourseId)?.course_description || ""}
//           batch={batchData?.find(b => b.id === selectedBatchId)?.label || ""}
//           isExpanded={isExpanded}
//         />
//       </div>
//     </div>
//   );
// };

// export default StudentTestPerformanceReport;

// import CustomSearchDropdown from "../../POP/FileComp5";
// import _ from "lodash";
// import { useSearchParams, useNavigate } from "react-router-dom";
// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import TableCompoenent from "./TableCompoenent";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import DropDownMultipleSelection from "../components/FieldsComponent"; // Using Multi-Select for all
// import FormInputs from "../DummyReportPage/FormInputs";
// import dayjs from "dayjs";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";

// const StudentTestPerformanceReport = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   pauseTimer,
//   resumeTimer,
//   dataClient,
//   setPagePath,
// }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { coursesdata } = useSelector((state) => state.course);

//   // --- UI States ---
//   const [resultsData, setResultsData] = useState([]);
//   const [headers, setHeaders] = useState([]);
//   const [isApplied, setIsApplied] = useState(false);
//   const [resetKey, setResetKey] = useState(0);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isVisible, setIsVisible] = useState(true);
//   const [disabled, setDisabled] = useState(false);
//   const [isExpanded, setIsExpanded] = useState(false);

//   // --- Dropdown Data States ---
//   const [sessionData, setSessionData] = useState([]);
//   const [batchData, setBatchData] = useState([]);
//   const [studentData, setStudentData] = useState([]);
//   const [v2AssessmentData, setV2AssessmentData] = useState([]);
//   const [v3TestData, setV3TestData] = useState([]);

//   // --- Selected Values States (All Arrays for Multi-Select) ---
//   const [selectedCourseIds, setSelectedCourseIds] = useState([]);
//   const [selectedSessionIds, setSelectedSessionIds] = useState([]);
//   const [selectedBatchIds, setSelectedBatchIds] = useState([]);
//   const [selectedStudents, setSelectedStudents] = useState([]);
//   const [selectedV3TestIds, setSelectedV3TestIds] = useState([]);
//   const [selectedV2AssessmentIds, setSelectedV2AssessmentIds] = useState([]);

//   // --- New Filter States ---
//   const [lastNTests, setLastNTests] = useState("");
//   const [lastNDays, setLastNDays] = useState("");

//   // --- Search States ---
//   const [searchKey, setSearchKey] = useState("");
//   const [searchColumn, setSearchColumn] = useState("");

//   // --- Date/Filter Logic ---
//   const [value, setValues] = useState({
//     month: "Month to Date",
//     start_month: "",
//     end_month: "",
//   });

//   const [searchParams] = useSearchParams();
//   const reportName = searchParams.get("reportName") || "Student Test Performance";

//   // --- 1. Initial Setup ---
//   useEffect(() => {
//     setPagePath("Reports > Reports Dashboard > Test Performance");
//     dispatch(fetchCourseData());
//     fetchSessionsData();
//   }, [dispatch]);

//   // --- 2. Cascading Dropdown Logic ---

//   // Auto-select most recent Session
//   useEffect(() => {
//     if (selectedCourseIds.length > 0 && sessionData.length > 0) {
//       const mostRecentSession = sessionData.reduce((prev, current) =>
//         prev.id > current.id ? prev : current
//       );
//       // Only set default if nothing is selected yet
//       if (selectedSessionIds.length === 0) {
//         setSelectedSessionIds([mostRecentSession.id]);
//       }
//     }
//   }, [selectedCourseIds, sessionData]);

//   // Fetch Batches when Courses change
//   useEffect(() => {
//     if (selectedCourseIds.length > 0) {
//       fetchBatchData();
//     } else {
//       setBatchData([]);
//     }
//     setSelectedBatchIds([]);
//     resetDownstreamFilters();
//   }, [selectedCourseIds]);

//   // Filter Batches by Selected Sessions
//   const filteredBatchData = useMemo(() => {
//     if (selectedSessionIds.length === 0) return batchData;
//     return batchData.filter((batch) => selectedSessionIds.includes(batch.session_id));
//   }, [batchData, selectedSessionIds]);

//   // Fetch Students when Batches change
//   useEffect(() => {
//     if (selectedCourseIds.length > 0 && selectedBatchIds.length > 0) {
//       fetchStudentData();
//     } else {
//       setStudentData([]);
//     }
//     resetDownstreamFilters();
//   }, [selectedBatchIds]);

//   // Fetch Tests & Assessments (from V3 API) when Student is selected
//   useEffect(() => {
//     if (selectedBatchIds.length > 0 && selectedStudents.length > 0) {
//       // Use first selected student and first selected batch for context
//       // (API limitation: endpoint takes single student_id and batch_id)
//       fetchTestsAndAssessments(selectedStudents[0], selectedBatchIds[0]);
//     } else {
//       setV3TestData([]);
//       setV2AssessmentData([]);
//     }
//   }, [selectedStudents, selectedBatchIds]);

//   const resetDownstreamFilters = () => {
//     setSelectedStudents([]);
//     setSelectedV3TestIds([]);
//     setSelectedV2AssessmentIds([]);
//     setStudentData([]);
//     setV3TestData([]);
//     setV2AssessmentData([]);
//   };

//   // --- 3. API Calls ---

//   const fetchSessionsData = async () => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-sessions-list`,
//         { headers: { accept: "application/json", "Content-Type": "application/json" } }
//       );
//       const result = await response.json();
//       if (result.status === 200 && result.data) {
//         setSessionData(result.data.map((s) => ({ id: s.session_id, label: s.session_name })));
//       }
//     } catch (error) {
//       console.error("Error fetching sessions:", error);
//     }
//   };

//   // Fetch batches for ALL selected courses
//   const fetchBatchData = async () => {
//     try {
//       const batchPromises = selectedCourseIds.map(courseId =>
//         fetch(
//           `${FULL_API_BASE_URL}/get-batches-by-course/?course_id=${courseId}`,
//           { headers: { accept: "application/json", "Content-Type": "application/json" } }
//         ).then(res => res.json())
//       );

//       const results = await Promise.all(batchPromises);

//       // Flatten and Unique
//       let allBatches = [];
//       results.forEach(data => {
//         if (Array.isArray(data)) {
//           allBatches = [...allBatches, ...data.map(b => ({
//             id: b.batch_id,
//             label: b.batch_name,
//             session_id: b.session_id,
//           }))];
//         }
//       });

//       setBatchData(_.uniqBy(allBatches, 'id'));
//     } catch (error) {
//       console.error("Error fetching batches:", error);
//     }
//   };

//   const fetchStudentData = useCallback(async () => {
//     try {
//       if (selectedCourseIds.length === 0 || selectedBatchIds.length === 0) return;

//       // API expects comma separated course_id param if multiple? Or single?
//       // The filter endpoint uses body params, so we pass selectedCourseIds[0] as query param for valid URL,
//       // but rely on body `batch_ids` for actual filtering.

//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-v2/?course_id=${selectedCourseIds[0]}`,
//         {
//           method: "POST",
//           headers: { accept: "application/json", "Content-Type": "application/json" },
//           body: JSON.stringify({
//             batch_ids: selectedBatchIds, // Passing Array of Batch IDs
//             student_ids: [],
//             search_key: searchKey,
//             search_column: searchColumn,
//           }),
//         }
//       );
//       const data = await response.json();
//       const uniqueStudents = _.uniqBy(data.student_list, "student_id");
//       setStudentData(uniqueStudents.map((s) => ({
//         id: s.student_id,
//         student_name: s.student_name,
//         roll_number: s.roll_number,
//         batch_name: s.batch_name,
//       })));
//     } catch (error) {
//       console.error("Error fetching students:", error);
//     }
//   }, [selectedCourseIds, selectedBatchIds, searchKey, searchColumn]);

//   // Combined fetch for V2 (Assessments) and V3 (Tests) using the V3 API
//   const fetchTestsAndAssessments = async (studentId, batchId) => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-tests-assignment-v3/?student_id=${studentId}&batch_id=${batchId}`,
//         { headers: { accept: "application/json", Authorization: `Bearer ${sessionStorage.getItem("other")}` } }
//       );
//       const result = await response.json();

//       if (result.status === 200 && result.data) {

//         // 1. Filter V3 Tests (Items having test_schedule_id)
//         const v3Data = result.data
//           .filter(item => item.test_schedule_id)
//           .map(item => ({
//             id: item.test_schedule_id,
//             label: item.assessment_name + (item.test_mode ? ` (${item.test_mode})` : "")
//           }));

//         // 2. Filter V2 Assessments (Items having assessment_id)
//         const v2Data = result.data
//           .filter(item => item.assessment_id) // Based on the API code structure provided
//           .map(item => ({
//             id: item.assessment_id, // Or item.assessment_assignment_id depending on what the report endpoint expects
//             label: item.assessment_name
//           }));

//         setV3TestData(_.uniqBy(v3Data, "id"));
//         setV2AssessmentData(_.uniqBy(v2Data, "id"));
//       }
//     } catch (error) {
//       console.error("Error fetching tests/assessments:", error);
//     }
//   };

//   // --- 4. Search & Helper Functions ---
//   const handleSearchKeyChange = (key, dropdownType) => {
//     if (key.length >= 3 && dropdownType === "student") {
//       setSearchKey(key);
//       setSearchColumn(dropdownType);
//     } else {
//       setSearchKey("");
//       setSearchColumn("");
//     }
//   };

//   const handleDropdownClose = () => {
//     if (selectedCourseIds.length > 0 && selectedBatchIds.length > 0) fetchStudentData();
//   };

//   const handleRadioChange = (selectedValue) => {
//     setValues(prev => ({ ...prev, month: prev.month === selectedValue ? "" : selectedValue }));
//   };

//   const calculateDates = () => {
//     const today = dayjs();
//     if (!value.month) return { from_date: "", end_date: "" };

//     let from_date = "", end_date = today.format("YYYY-MM-DD");
//     switch (value.month) {
//       case "Last Month":
//         from_date = today.subtract(1, "month").startOf("month").format("YYYY-MM-DD");
//         end_date = today.subtract(1, "month").endOf("month").format("YYYY-MM-DD");
//         break;
//       case "Month to Date":
//         from_date = today.startOf("month").format("YYYY-MM-DD");
//         break;
//       case "Week to Date":
//         from_date = today.startOf("week").format("YYYY-MM-DD");
//         break;
//       case "Custom":
//         from_date = value.start_month;
//         end_date = value.end_month;
//         break;
//       default: break;
//     }
//     return { from_date, end_date };
//   };

//   // --- 5. Apply / Reset ---
//   const handleApplyOrReset = async () => {
//     if (isApplied) {
//       setResultsData([]);
//       setHeaders([]);
//       setIsApplied(false);
//       setIsColumnDivVisible(false);
//       setDisabled(false);
//       setResetKey(prev => prev + 1);
//       setLastNTests("");
//       setLastNDays("");
//     } else {
//       setIsApplied(true);
//       setDisabled(true);
//       const { from_date, end_date } = calculateDates();

//       // IMPORTANT: Backend expects comma-separated strings for multi-selects
//       const params = new URLSearchParams();
//       if (selectedBatchIds.length > 0) params.append("batch_ids", selectedBatchIds.join(","));
//       if (selectedCourseIds.length > 0) params.append("course_ids", selectedCourseIds.join(","));
//       if (selectedSessionIds.length > 0) params.append("session_ids", selectedSessionIds.join(","));
//       if (selectedStudents.length > 0) params.append("student_ids", selectedStudents.join(","));
//       if (selectedV3TestIds.length > 0) params.append("test_schedule_ids", selectedV3TestIds.join(","));
//       if (selectedV2AssessmentIds.length > 0) params.append("assessment_assignment_ids", selectedV2AssessmentIds.join(","));

//       if (lastNTests) params.append("last_n_tests", lastNTests);
//       if (lastNDays) params.append("last_n_days", lastNDays);

//       if (from_date && !lastNTests && !lastNDays) params.append("from_date", from_date);
//       if (end_date && !lastNTests && !lastNDays) params.append("end_date", end_date);

//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/student-test-performance?${params.toString()}`,
//           {
//             method: "GET",
//             headers: {
//               accept: "application/json",
//               Authorization: `Bearer ${sessionStorage.getItem("other")}`
//             },
//           }
//         );

//         const result = await response.json();

//         if (Array.isArray(result) && result.length > 1) {
//           const rawHeaders = result[0];
//           const cleanHeaders = rawHeaders.map(h => h.replace(/^[nt]\*/, ""));

//           setHeaders(cleanHeaders);
//           setResultsData(result.slice(1));
//         } else {
//           setResultsData([]);
//           showError("No data found for the selected filters.", InterogativeImg);
//         }
//       } catch (error) {
//         console.error(error);
//         setResultsData([]);
//         showError("Failed to generate report.", ErrorImg);
//       }
//     }
//   };

//   const showError = (msg, img) => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX" onMouseEnter={pauseTimer} onMouseLeave={resumeTimer}>
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>{msg}</span>
//         </div>
//       </div>
//     );
//     setActiveImg(img);
//   };

//   const dropdownStyle = isApplied ? { opacity: 0.5, pointerEvents: "none" } : { opacity: 1, pointerEvents: "auto" };

//   return (
//     <div style={{ height: "auto", width: "100%", paddingLeft: "36.5px", marginBottom: "40px" }}>
//       {/* --- Header --- */}
//       <div style={{ position: "sticky", top: "0" }}>
//         <div className="Header-up">
//           <span style={{ color: "#2F2E40", fontSize: "30px", textTransform: "capitalize" }}>
//             {reportName}
//           </span>
//           <div className="testreportcard-header-btn-container" style={{ marginRight: "30px" }}>
//             <button
//               className="testreportcard-cancel-btn"
//               onClick={() => {
//                 navigate("/report_management");
//                 setPagePath("Reports > Reports Dashboard");
//               }}
//             >
//               CANCEL
//             </button>
//             <button className="testreportcard-create-btn" onClick={handleApplyOrReset}>
//               {isApplied ? "RESET" : "APPLY"}
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* --- Filter Section --- */}
//       <div style={{ display: isVisible ? "block" : "none", marginTop: "1vh" }}>

//         {/* Row 1: Course, Session, Batch (Multi-Select) */}
//         <div className="row-cs-uni">
//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }} key={`course_${resetKey}`}>
//             <DropDownMultipleSelection
//               label="Course"
//               width="13.5vw"
//               selected={selectedCourseIds}
//               setSelected={setSelectedCourseIds}
//               options={coursesdata ? coursesdata.map(c => ({ id: c.course_id, label: c.course_description })) : []}
//               customWidth="100%"
//               showSelectAll={true}
//             />
//           </div>
//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }} key={`session_${resetKey}`}>
//             <DropDownMultipleSelection
//               label="Select Session"
//               width="13.5vw"
//               selected={selectedSessionIds}
//               setSelected={setSelectedSessionIds}
//               options={sessionData}
//               customWidth="100%"
//               showSelectAll={true}
//             />
//           </div>
//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }} key={`batch_${resetKey}`}>
//             <DropDownMultipleSelection
//               label="Select Batch"
//               width="13.5vw"
//               selected={selectedBatchIds}
//               setSelected={setSelectedBatchIds}
//               options={filteredBatchData}
//               customWidth="100%"
//               showSelectAll={true}
//               disabled={selectedCourseIds.length === 0}
//             />
//           </div>
//         </div>

//         {/* Row 2: Student, Assessments, Tests */}
//         <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//           {/* Student Dropdown (Multi Select) */}
//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }} key={`student_${resetKey}`}>
//             <CustomSearchDropdown
//               label="Select Student"
//               optionsData={studentData}
//               selected={selectedStudents}
//               setSelected={setSelectedStudents}
//               placeholder="Search Student..."
//               headers={["Student Name", "Roll Number", "Batch"]}
//               optionFields={{ option1: "student_name", option2: "roll_number", option3: "batch_name" }}
//               onDropdownClose={handleDropdownClose}
//               onSearchKeyChange={(key) => handleSearchKeyChange(key, "student")}
//               customwidth="13.5vw"
//               dropdownWidth="13.5vw"
//             />
//           </div>

//           {/* Assessments Dropdown (Populated via get-tests-assignment-v3, filtering for assessment_id) */}
//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }} key={`v2_${resetKey}`}>
//             <DropDownMultipleSelection
//               width="13.5vw"
//               label="Assessments"
//               selected={selectedV2AssessmentIds}
//               setSelected={setSelectedV2AssessmentIds}
//               options={v2AssessmentData}
//               customWidth="100%"
//               showSelectAll={true}
//               disabled={selectedStudents.length === 0}
//             />
//           </div>

//           {/* Tests Dropdown (Populated via get-tests-assignment-v3, filtering for test_schedule_id) */}
//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }} key={`v3_${resetKey}`}>
//             <DropDownMultipleSelection
//               width="13.5vw"
//               label="Tests"
//               selected={selectedV3TestIds}
//               setSelected={setSelectedV3TestIds}
//               options={v3TestData}
//               customWidth="100%"
//               showSelectAll={true}
//               disabled={selectedStudents.length === 0}
//             />
//           </div>
//         </div>

//         {/* Row 3: Advanced Filters (Last N Tests, Last N Days) */}
//         <div className="row-cs-uni" style={{ marginTop: "1vh", alignItems: "center" }}>
//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }}>
//             <label style={{ fontSize: "14px", color: "#2F2E40", marginRight: "10px", marginBottom: '5px', display:'block' }}>Last N Tests:</label>
//             <FormInputs
//               type="number"
//               placeholder="e.g. 5"
//               value={lastNTests}
//               onChange={(e) => setLastNTests(e.target.value)}
//               disabled={isApplied}
//               style={{ width: "13.5vw", height: "42px", border: "1px solid #ccc", paddingLeft: "5px", borderRadius: "4px" }}
//             />
//           </div>

//           <div className="col-cs2" style={{ marginRight: "1vw", ...dropdownStyle }}>
//             <label style={{ fontSize: "14px", color: "#2F2E40", marginRight: "10px", marginBottom: '5px', display:'block' }}>Last N Days:</label>
//             <FormInputs
//               type="number"
//               placeholder="e.g. 30"
//               value={lastNDays}
//               onChange={(e) => setLastNDays(e.target.value)}
//               disabled={isApplied}
//               style={{ width: "13.5vw", height: "42px", border: "1px solid #ccc", paddingLeft: "5px", borderRadius: "4px" }}
//             />
//           </div>
//         </div>

//         {/* Row 4: Date Filters */}
//         <div className="grid-container-radio-button" style={{ marginTop: "1vh", height: "35px", ...dropdownStyle }}>
//           {["Last Month", "Month to Date", "Week to Date", "Custom"].map((opt) => (
//             <div className={`item${opt === "Custom" ? 8 : 5}`} key={opt}>
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id={opt}
//                   name="month"
//                   value={opt}
//                   checked={value.month === opt}
//                   onClick={() => handleRadioChange(opt)}
//                   onChange={()=>{}}
//                   disabled={isApplied || lastNTests || lastNDays}
//                 />
//                 <label htmlFor={opt}>{opt}</label>
//               </div>
//             </div>
//           ))}

//           {value.month === "Custom" && (
//             <>
//               <div className="item9">
//                 <FormInputs type="date" value={value.start_month} onChange={(e) => setValues({ ...value, start_month: e.target.value })} disabled={isApplied || lastNTests || lastNDays} />
//               </div>
//               <div className="item10">To</div>
//               <div className="item11">
//                 <FormInputs type="date" value={value.end_month} onChange={(e) => setValues({ ...value, end_month: e.target.value })} disabled={isApplied || lastNTests || lastNDays} />
//               </div>
//             </>
//           )}
//         </div>

//       </div>

//       {/* --- Table Section --- */}
//       <div style={{ position: "relative", marginTop: "20px" }}>
//         <button
//           style={{
//             position: "absolute",
//             top: "-1px",
//             left: "50%",
//             transform: "translateX(-50%)",
//             zIndex: 1,
//             width: "60px",
//             height: "10px",
//             backgroundColor: "white",
//             border: "none",
//             cursor: 'pointer'
//           }}
//           onClick={() => {
//             setIsExpanded(!isExpanded);
//             setIsVisible(!isVisible);
//           }}
//         >
//           <p style={{ fontSize: "20px", color: "black", margin: 0, lineHeight: "10px" }}>...</p>
//         </button>

//         <TableCompoenent
//           headers={headers}
//           data={resultsData}
//           searchPlaceholder="Search results..."
//           isColumnDivVisible={isColumnDivVisible}
//           setIsColumnDivVisible={setIsColumnDivVisible}
//           dataClient={dataClient}
//           ReportPageHeader={reportName}
//           course={coursesdata?.find(c => selectedCourseIds.includes(c.course_id))?.course_description || ""}
//           batch={batchData?.find(b => selectedBatchIds.includes(b.id))?.label || ""}
//           isExpanded={isExpanded}
//         />
//       </div>
//     </div>
//   );
// };

// export default StudentTestPerformanceReport;

import CustomSearchDropdown from "../../POP/FileComp5";
import _ from "lodash";
import { useSearchParams, useNavigate } from "react-router-dom";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import TableCompoenent from "./TableCompoenent";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import { useDispatch, useSelector } from "react-redux";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import DropDownMultipleSelection from "../components/FieldsComponent";
import FormInputs from "../DummyReportPage/FormInputs";
import dayjs from "dayjs";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";

const StudentTestPerformanceReport = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  pauseTimer,
  resumeTimer,
  dataClient,
  setPagePath,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { coursesdata } = useSelector((state) => state.course);

  // --- UI States ---
  const [resultsData, setResultsData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [isApplied, setIsApplied] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  // --- Dropdown Data States ---
  const [sessionData, setSessionData] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [v2AssessmentData, setV2AssessmentData] = useState([]);
  const [v3TestData, setV3TestData] = useState([]);

  // --- Selection States ---
  const [selectedCourseIds, setSelectedCourseIds] = useState([]);
  const [selectedSessionIds, setSelectedSessionIds] = useState([]);
  const [selectedBatchIds, setSelectedBatchIds] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectedV3TestIds, setSelectedV3TestIds] = useState([]);
  const [selectedV2AssessmentIds, setSelectedV2AssessmentIds] = useState([]);

  // --- Filter States ---
  const [lastNTests, setLastNTests] = useState("");
  const [lastNDays, setLastNDays] = useState("");
  const [value, setValues] = useState({
    month: "Month to Date",
    start_month: "",
    end_month: "",
  });

  // --- Search States for Student Dropdown ---
  const [searchKey, setSearchKey] = useState("");
  const [searchColumn, setSearchColumn] = useState("");

  const [searchParams] = useSearchParams();
  const reportName =
    searchParams.get("reportName") || "Student Test Performance";

  // --- 1. Initial Setup ---
  useEffect(() => {
    setPagePath("Reports > Reports Dashboard > Test Performance");
    dispatch(fetchCourseData());
    fetchSessionsData();
  }, [dispatch]);

  // --- 2. Session Auto Selection (Fixed) ---
  useEffect(() => {
    if (
      selectedCourseIds.length > 0 &&
      sessionData.length > 0 &&
      selectedSessionIds.length === 0
    ) {
      const mostRecentSession = sessionData.reduce((prev, current) =>
        prev.id > current.id ? prev : current
      );
      if (mostRecentSession) setSelectedSessionIds([mostRecentSession.id]);
    }
  }, [selectedCourseIds, sessionData]);

  // --- 3. Cascading Logic ---

  // A. WHEN COURSE CHANGES
  useEffect(() => {
    if (selectedCourseIds.length > 0) {
      fetchBatchData();
      // LOGIC: If no batch selected yet, populate students by Course ID
      if (selectedBatchIds.length === 0) {
        fetchStudentByCourse();
      }
    } else {
      setBatchData([]);
      setStudentData([]);
    }

    // Clear downstream
    setSelectedBatchIds([]);
    setSelectedStudents([]);
    resetTests();
  }, [selectedCourseIds]);

  // B. WHEN BATCH CHANGES
  useEffect(() => {
    if (selectedBatchIds.length > 0) {
      // RESET RULE: If user changes batch, clear student & tests completely
      if (selectedStudents.length > 0) {
        setSelectedStudents([]);
        resetTests();
      }

      // LOGIC: Filter students by Batch (The original POST API)
      fetchStudentByBatchFilter();

      // LOGIC: If only batch is selected, populate tests using Batch API
      fetchTestsByBatch();
    } else {
      // Fallback: If batch deselected but course remains, revert student list
      if (selectedCourseIds.length > 0) fetchStudentByCourse();
      resetTests();
    }
  }, [selectedBatchIds]);

  // C. WHEN STUDENT CHANGES
  useEffect(() => {
    if (selectedStudents.length > 0) {
      // Clear search text after selection (Logic requirement)
      setSearchKey("");
      setSearchColumn("");

      // LOGIC CHECK: Which test API to call?
      if (selectedBatchIds.length > 0) {
        // Case 1: Batch + Student Selected -> Call V3 API
        fetchTestsByStudentAndBatchV3();
      } else {
        // Case 2: Only Student Selected (via Course) -> Call Student-ID API
        fetchTestsByStudent();
      }
    } else {
      // Fallback: If student deselected but batch exists, show Batch Tests again
      if (selectedBatchIds.length > 0) {
        fetchTestsByBatch();
      } else {
        resetTests();
      }
    }
  }, [selectedStudents]);

  const resetTests = () => {
    setSelectedV3TestIds([]);
    setSelectedV2AssessmentIds([]);
    setV3TestData([]);
    setV2AssessmentData([]);
  };

  // --- 4. API Implementations ---

  const fetchSessionsData = async () => {
    try {
      const response = await fetch(`${FULL_API_BASE_URL}/get-sessions-list`);
      const result = await response.json();
      if (result.status === 200)
        setSessionData(
          result.data.map((s) => ({ id: s.session_id, label: s.session_name }))
        );
    } catch (e) {
      console.error(e);
    }
  };

  const fetchBatchData = async () => {
    try {
      const res = await fetch(
        `${FULL_API_BASE_URL}/get-batches-by-course/?course_id=${selectedCourseIds[0]}`
      );
      const data = await res.json();
      setBatchData(
        data.map((b) => ({
          id: b.batch_id,
          label: b.batch_name,
          session_id: b.session_id,
        }))
      );
    } catch (e) {
      console.error(e);
    }
  };

  // API 1: get-student-list-by-course
  const fetchStudentByCourse = async () => {
    try {
      const res = await fetch(
        `${FULL_API_BASE_URL}/get-student-list-by-course/?course_id=${selectedCourseIds[0]}`
      );
      const result = await res.json();
      if (result.status === 200) {
        setStudentData(
          result.data.map((s) => ({
            id: s.student_id,
            student_name: s.student_name,
            roll_number: s.roll_number,
            batch_name: s.batch_name,
          }))
        );
      }
    } catch (e) {
      console.error(e);
    }
  };

  // API: Fetch students filtered by Batch (POST)
  const fetchStudentByBatchFilter = useCallback(async () => {
    try {
      if (selectedCourseIds.length === 0 || selectedBatchIds.length === 0)
        return;

      const response = await fetch(
        `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-v2/?course_id=${selectedCourseIds[0]}`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            batch_ids: selectedBatchIds,
            student_ids: [],
            search_key: searchKey,
            search_column: searchColumn,
          }),
        }
      );
      const data = await response.json();
      const uniqueStudents = _.uniqBy(data.student_list, "student_id");
      setStudentData(
        uniqueStudents.map((s) => ({
          id: s.student_id,
          student_name: s.student_name,
          roll_number: s.roll_number,
          batch_name: s.batch_name,
        }))
      );
    } catch (error) {
      console.error("Error fetching students by batch:", error);
    }
  }, [selectedCourseIds, selectedBatchIds, searchKey, searchColumn]);

  // API 2: get-tests-assignments-by-batch
  const fetchTestsByBatch = async () => {
    try {
      const res = await fetch(
        `${FULL_API_BASE_URL}/get-tests-assignments-by-batch/?batch_id=${selectedBatchIds[0]}`
      );
      const result = await res.json();
      if (result.status === 200) processTests(result.data);
    } catch (e) {
      console.error(e);
    }
  };

  // API 3: get-tests-assignment-by-student-id
  const fetchTestsByStudent = async () => {
    try {
      const res = await fetch(
        `${FULL_API_BASE_URL}/get-tests-assignment-by-student-id/?student_id=${selectedStudents[0]}`
      );
      const result = await res.json();
      if (result.status === 200) processTests(result.data);
    } catch (e) {
      console.error(e);
    }
  };

  // API 4: get-tests-assignment-v3
  const fetchTestsByStudentAndBatchV3 = async () => {
    try {
      const res = await fetch(
        `${FULL_API_BASE_URL}/get-tests-assignment-v3/?student_id=${selectedStudents[0]}&batch_id=${selectedBatchIds[0]}`,
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("other")}`,
          },
        }
      );
      const result = await res.json();
      if (result.status === 200) processTests(result.data);
    } catch (e) {
      console.error(e);
    }
  };

  const processTests = (data) => {
    const v3 = data
      .filter((i) => i.test_schedule_id)
      .map((i) => ({ id: i.test_schedule_id, label: i.assessment_name }));
    const v2 = data
      .filter((i) => i.assessment_id)
      .map((i) => ({ id: i.assessment_id, label: i.assessment_name }));
    setV3TestData(_.uniqBy(v3, "id"));
    setV2AssessmentData(_.uniqBy(v2, "id"));
  };

  // --- 5. Handlers ---
  const handleSearchKeyChange = (key, dropdownType) => {
    if (key.length >= 3 && dropdownType === "student") {
      setSearchKey(key);
      setSearchColumn(dropdownType);
    } else {
      setSearchKey("");
      setSearchColumn("");
    }
  };

  const handleDropdownClose = () => {
    if (selectedCourseIds.length > 0 && selectedBatchIds.length > 0)
      fetchStudentByBatchFilter();
  };

  const handleRadioChange = (selectedValue) => {
    setValues((prev) => ({
      ...prev,
      month: prev.month === selectedValue ? "" : selectedValue,
    }));
  };

  const calculateDates = () => {
    const today = dayjs();
    if (!value.month) return { from_date: "", end_date: "" };
    let from_date = "",
      end_date = today.format("YYYY-MM-DD");
    switch (value.month) {
      case "Last Month":
        from_date = today
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
        end_date = today
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD");
        break;
      case "Month to Date":
        from_date = today.startOf("month").format("YYYY-MM-DD");
        break;
      case "Week to Date":
        from_date = today.startOf("week").format("YYYY-MM-DD");
        break;
      case "Custom":
        from_date = value.start_month;
        end_date = value.end_month;
        break;
      default:
        break;
    }
    return { from_date, end_date };
  };

  // --- 6. Apply / Reset ---
  const handleApplyOrReset = async () => {
    if (isApplied) {
      setResultsData([]);
      setHeaders([]);
      setIsApplied(false);
      setResetKey((p) => p + 1);
      setLastNTests("");
      setLastNDays("");
    } else {
      setIsApplied(true);
      const { from_date, end_date } = calculateDates();
      const params = new URLSearchParams();

      if (selectedBatchIds.length > 0)
        params.append("batch_ids", selectedBatchIds.join(","));
      if (selectedCourseIds.length > 0)
        params.append("course_ids", selectedCourseIds.join(","));
      if (selectedSessionIds.length > 0)
        params.append("session_ids", selectedSessionIds.join(","));
      if (selectedStudents.length > 0)
        params.append("student_ids", selectedStudents.join(","));
      if (selectedV3TestIds.length > 0)
        params.append("test_schedule_ids", selectedV3TestIds.join(","));
      if (selectedV2AssessmentIds.length > 0)
        params.append(
          "assessment_assignment_ids",
          selectedV2AssessmentIds.join(",")
        );

      if (lastNTests) params.append("last_n_tests", lastNTests);
      if (lastNDays) params.append("last_n_days", lastNDays);
      if (from_date && !lastNTests && !lastNDays)
        params.append("from_date", from_date);
      if (end_date && !lastNTests && !lastNDays)
        params.append("end_date", end_date);

      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/student-test-performance?${params.toString()}`,
          {
            method: "GET",
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${sessionStorage.getItem("other")}`,
            },
          }
        );
        const result = await response.json();
        if (Array.isArray(result) && result.length > 1) {
          setHeaders(result[0].map((h) => h.replace(/^[nt]\*/, "")));
          setResultsData(result.slice(1));
        } else {
          showError("No data found for the selected filters.", InterogativeImg);
        }
      } catch (e) {
        console.error(e);
        showError("Failed to generate report.", ErrorImg);
      }
    }
  };

  const showError = (msg, img) => {
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div
        className="Container-messageBOX"
        onMouseEnter={pauseTimer}
        onMouseLeave={resumeTimer}
      >
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>{msg}</span>
        </div>
      </div>
    );
    setActiveImg(img);
  };

  const dropdownStyle = isApplied
    ? { opacity: 0.5, pointerEvents: "none" }
    : { opacity: 1, pointerEvents: "auto" };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "36.5px",
        marginBottom: "40px",
      }}
    >
      <style>{`
        .filter-row-full { display: flex; justify-content: space-between; gap: 20px; margin-bottom: 10px; width: 100%; padding-right: 30px }
        .filter-col-3 { flex: 1; min-width: 0; }
        .filter-col-3 > div { width: 100% !important; }
      `}</style>

      {/* --- Header --- */}
      <div style={{ position: "sticky", top: "0", zIndex: 100 }}>
        <div className="Header-up">
          <span
            style={{
              color: "#2F2E40",
              fontSize: "30px",
              textTransform: "capitalize",
            }}
          >
            {reportName}
          </span>
          <div
            className="testreportcard-header-btn-container"
            style={{ marginRight: "30px" }}
          >
            <button
              className="testreportcard-cancel-btn"
              onClick={() => {
                navigate("/report_management");
                setPagePath("Reports > Reports Dashboard");
              }}
            >
              CANCEL
            </button>
            <button
              className="testreportcard-create-btn"
              onClick={handleApplyOrReset}
            >
              {isApplied ? "RESET" : "APPLY"}
            </button>
          </div>
        </div>
      </div>

      {/* --- Filters --- */}
      {isVisible && (
        <div style={{ ...dropdownStyle, marginTop: "1vh" }}>
          {/* Row 1: Course, Session, Batch */}
          <div className="filter-row-full">
            <div className="filter-col-3">
              <DropDownMultipleSelection
                label="Course"
                selected={selectedCourseIds}
                setSelected={setSelectedCourseIds}
                options={
                  coursesdata?.map((c) => ({
                    id: c.course_id,
                    label: c.course_description,
                  })) || []
                }
                customWidth="100%"
                setIsColumnDivVisible={setIsColumnDivVisible}
              />
            </div>
            <div className="filter-col-3">
              <DropDownMultipleSelection
                label="Select Session"
                selected={selectedSessionIds}
                setSelected={setSelectedSessionIds}
                options={sessionData}
                customWidth="100%"
                setIsColumnDivVisible={setIsColumnDivVisible}
              />
            </div>
            <div className="filter-col-3">
              <DropDownMultipleSelection
                label="Select Batch"
                selected={selectedBatchIds}
                setSelected={setSelectedBatchIds}
                options={batchData.filter(
                  (b) =>
                    !selectedSessionIds.length ||
                    selectedSessionIds.includes(b.session_id)
                )}
                customWidth="100%"
                setIsColumnDivVisible={setIsColumnDivVisible}
              />
            </div>
          </div>

          {/* Row 2: Student, Assessments, Tests */}
          <div className="filter-row-full">
            <div className="filter-col-3">
              {/* Added Key to force re-render/reset when batch changes */}
              <CustomSearchDropdown
                key={`student-drop-${selectedBatchIds.join("-")}`}
                label="Select Student"
                optionsData={studentData}
                selected={selectedStudents}
                setSelected={setSelectedStudents}
                placeholder="Search Student..."
                // Ensure these match your CustomSearchDropdown internal logic for headers/columns
                headers={["Student Name", "Roll Number", "Batch"]}
                optionFields={{
                  option1: "student_name",
                  option2: "roll_number",
                  option3: "batch_name",
                }}
                customwidth="100%"
                dropdownWidth="100%"
                setIsColumnDivVisible={setIsColumnDivVisible}
                onDropdownClose={handleDropdownClose}
                onSearchKeyChange={(key) =>
                  handleSearchKeyChange(key, "student")
                }
              />
            </div>
            <div className="filter-col-3">
              <DropDownMultipleSelection
                key={`assess-drop-${selectedStudents.join("-")}`}
                label="Assessments"
                selected={selectedV2AssessmentIds}
                setSelected={setSelectedV2AssessmentIds}
                options={v2AssessmentData}
                customWidth="100%"
                setIsColumnDivVisible={setIsColumnDivVisible}
              />
            </div>
            <div className="filter-col-3">
              <DropDownMultipleSelection
                key={`test-drop-${selectedStudents.join("-")}`}
                label="Tests"
                selected={selectedV3TestIds}
                setSelected={setSelectedV3TestIds}
                options={v3TestData}
                customWidth="100%"
                setIsColumnDivVisible={setIsColumnDivVisible}
              />
            </div>
          </div>

          {/* Row 3: N Filters */}
          <div className="filter-row-full">
            <div className="filter-col-3">
              <label
                style={{
                  fontSize: "14px",
                  color: "#2F2E40",
                  marginBottom: "0px",
                  display: "block",
                }}
              >
                Last N Tests:
              </label>
              <FormInputs
                type="number"
                placeholder="e.g. 5"
                value={lastNTests}
                onChange={(e) => setLastNTests(e.target.value)}
                disabled={isApplied}
                style={{
                  width: "100%",
                  height: "42px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  paddingLeft: "10px",
                }}
              />
            </div>
            <div className="filter-col-3">
              <label
                style={{
                  fontSize: "14px",
                  color: "#2F2E40",
                  marginBottom: "0px",
                  display: "block",
                }}
              >
                Last N Days:
              </label>
              <FormInputs
                type="number"
                placeholder="e.g. 30"
                value={lastNDays}
                onChange={(e) => setLastNDays(e.target.value)}
                disabled={isApplied}
                style={{
                  width: "100%",
                  height: "42px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  paddingLeft: "10px",
                }}
              />
            </div>
            <div className="filter-col-3"></div>
          </div>

          {/* Row 4: Date Radios */}
          <div
            className="grid-container-radio-button"
            style={{
              marginTop: "1vh",
              height: "35px",
              display: "flex",
              gap: "20px",
            }}
          >
            {["Last Month", "Month to Date", "Week to Date", "Custom"].map(
              (opt) => (
                <div
                  key={opt}
                  className="toggle-radio"
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <input
                    type="radio"
                    id={opt}
                    name="month"
                    value={opt}
                    checked={value.month === opt}
                    onClick={() => handleRadioChange(opt)}
                    onChange={() => {}}
                    disabled={isApplied || lastNTests || lastNDays}
                  />
                  <label
                    htmlFor={opt}
                    style={{ fontSize: "14px", cursor: "pointer" }}
                  >
                    {opt}
                  </label>
                </div>
              )
            )}
            {value.month === "Custom" && (
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <FormInputs
                  type="date"
                  value={value.start_month}
                  onChange={(e) =>
                    setValues({ ...value, start_month: e.target.value })
                  }
                  disabled={isApplied}
                />
                <span>To</span>
                <FormInputs
                  type="date"
                  value={value.end_month}
                  onChange={(e) =>
                    setValues({ ...value, end_month: e.target.value })
                  }
                  disabled={isApplied}
                />
              </div>
            )}
          </div>
        </div>
      )}

      {/* --- Table Section --- */}
      <div style={{ position: "relative", marginTop: "20px" }}>
        <button
          style={{
            position: "absolute",
            top: "-1px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1,
            width: "60px",
            height: "10px",
            backgroundColor: "white",
            border: "none",
            cursor: "pointer",
          }}
          onClick={() => {
            setIsExpanded(!isExpanded);
            setIsVisible(!isVisible);
          }}
        >
          <p
            style={{
              fontSize: "20px",
              color: "black",
              margin: 0,
              lineHeight: "10px",
            }}
          >
            ...
          </p>
        </button>

        <TableCompoenent
          headers={headers}
          data={resultsData}
          searchPlaceholder="Search results..."
          isColumnDivVisible={isColumnDivVisible}
          setIsColumnDivVisible={setIsColumnDivVisible}
          dataClient={dataClient}
          ReportPageHeader={reportName}
          course={
            coursesdata?.find((c) => selectedCourseIds.includes(c.course_id))
              ?.course_description || ""
          }
          batch={
            batchData?.find((b) => selectedBatchIds.includes(b.id))?.label || ""
          }
          isExpanded={isExpanded}
        />
      </div>
    </div>
  );
};

export default StudentTestPerformanceReport;
